<template>
  <div>
    <table class="table mb-0 table-striped">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">#</th>
          <th scope="col" class="border-0">Nome</th>
          <th scope="col" class="border-0">Número de Série</th>
          <th scope="col" class="border-0">Categoria</th>
          <th scope="col" class="border-0">Data de Validade</th>
          <th scope="col" class="border-0">Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in equipments" :key="row.id" class="align-items-center">
          <td class="td-1">{{ row.id }}</td>
          <td class="td-4 link">
            <d-link :to="{ name: 'admin-equipment-edit', params: { equipmentId: row.id }}">{{ row.name }}</d-link>
          </td>
          <td class="td-2">{{ row.serial_number || '' }}</td>
          <td class="td-2">{{ row.category ? row.category.name : '' }}</td>
          <td class="td-2">
            <span>{{ row.expiration_date }}</span>
          </td>
          <td class="td-2">
            <equipment-buttons :equipment="row"></equipment-buttons>
          </td>
        </tr>
        <tr v-if="equipments.length === 0">
          <td colspan="6" class="no-content">Ainda não tem nenhum equipamento.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EquipmentButtons from '_modules/equipment/components/EquipmentButtons.vue';

export default {
  name: 'equipment-table',
  components: {
    EquipmentButtons,
  },
  props: {
    equipments: {
      type: Array,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.align-items-center {
  td {
    vertical-align: middle;
  }
  .btn-sm { padding: 0.4rem 0.7rem; }
}

.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }

}
</style>
